/*
 * div link
 */
jQuery(function($){
	$(document).on(oEventNames.end, '.div-link', function (event) {
		if (!bIsScrolling) {
			event.preventDefault();
			if (jQuery(this).attr('data-target') != undefined) {
				open(jQuery(this).attr('data-href'), "_blank");
			} else {
				location.href = jQuery(this).attr('data-href');
			}
		}
	});
	// 上記のグループクリックで、イベントの伝播を防ぐ（ページ遷移させない）
	$(document).on(oEventNames.end, '.div-link .group-link-exclude', function (event) {
		event.stopPropagation();
	});
});